import MdsTabs from './tabs.vue';
import MdsTabsItem from './tabs-item.vue';

export { MdsTabs, MdsTabsItem };
export default MdsTabs;
